module.exports = __webpack_public_path__ + "static/media/bookmarks_blue.8a680f50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/bookmarks_blue.svg
// module id = ./src/assets/media/forum/bookmarks_blue.svg
// module chunks = 16